import { render, staticRenderFns } from "./CategorySettings.vue?vue&type=template&id=e7033164&scoped=true"
import script from "./CategorySettings.vue?vue&type=script&lang=js"
export * from "./CategorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7033164",
  null
  
)

export default component.exports